import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import authGuard from './guards/auth';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach(authGuard);

export default router;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/router/index.ts